export default {
    ATMOS_POPULATE_SUBSCRIPTIONS(state, subs) {
        state.atmosSubscriptions = subs;
    },

    ATMOS_CHANGE_SUBSCRIPTION(state, sub) {
        state.atmosSubscription = sub;
    },

    ATMOS_POPULATE_APPTYPES(state, appTypes) {
        state.atmosAppTypes = appTypes;
    },

    ATMOS_CLEAR_APPS(state) {
        state.atmosAppsRefreshing = true;
    },

    ATMOS_POPULATE_APPS(state, apps) {
        state.atmosApps = apps;
        state.atmosAppsRefreshing = false;
        state.atmosInitialized = true;
    },

    ATMOS_ADD_SUBSCRIPTION(state, sub) {
        state.atmosSubscriptions.push(sub);
    },

    ATMOS_UPDATE_SUBSCRIPTION(state, sub) {
        var idx = state.atmosSubscriptions.findIndex(i => i.id == sub.id);
        state.atmosSubscriptions[idx] = sub;
    },

    ATMOS_ADD_APP(state, app) {
        state.atmosApps.push(app);
    },

    ATMOS_UPDATE_SHOWPRERELEASES(state, flag) {
        state.showPrereleases = flag;
    },

    ATMOS_UPDATE_SHOWVERSIONS(state, flag) {
        state.showVersions = flag;
    }
}
